import CustomerActionTypes from './actionTypes';

const initialState = {
  customers: [],
  totalCustomers: 0,
  customerBookings: [],
  totalCustomerBookings: 0,
  customerDetails: null,
  customersLoading: true,
  customerDetailsLoading: true,
  customerBookingsLoading: true,
  exportCustomerLoading: false,
};

export default function customer(state = initialState, action) {
  switch (action.type) {
    case CustomerActionTypes.GET_CUSTOMERS:
      return {
        ...state,
        customersLoading: true,
      };
    case CustomerActionTypes.GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customersLoading: false,
        customers: action.payload.data,
        totalCustomers: action.payload.total,
      };
    case CustomerActionTypes.GET_CUSTOMERS_FAILED:
      return {
        ...state,
        customersLoading: false,
      };

    case CustomerActionTypes.GET_CUSTOMER_DETAILS:
      return {
        ...state,
        customerDetailsLoading: true,
      };
    case CustomerActionTypes.GET_CUSTOMER_DETAILS_SUCCESS:
      return {
        ...state,
        customerDetailsLoading: false,
        customerDetails: action.payload,
      };
    case CustomerActionTypes.GET_CUSTOMER_DETAILS_FAILED:
      return {
        ...state,
        customerDetailsLoading: false,
      };

    case CustomerActionTypes.GET_CUSTOMER_BOOKINGS:
      return {
        ...state,
        customerBookingsLoading: true,
      };
    case CustomerActionTypes.GET_CUSTOMER_BOOKINGS_SUCCESS:
      return {
        ...state,
        customerBookingsLoading: false,
        customerBookings: action.payload.data || [],
        totalCustomerBookings: action.payload.total || 0,
      };
    case CustomerActionTypes.GET_CUSTOMER_BOOKINGS_FAILED:
      return {
        ...state,
        customerBookingsLoading: false,
      };

    case CustomerActionTypes.EXPORT_CUSTOMER_FILE:
      return {
        ...state,
        exportCustomerLoading: true,
      };
    case CustomerActionTypes.EXPORT_CUSTOMER_FILE_SUCCESS:
    case CustomerActionTypes.EXPORT_CUSTOMER_FILE_FAILED:
      return {
        ...state,
        exportCustomerLoading: false,
      };

    default: return state;
  }
}
